/* global axios */

const knowledgeProxy = (accountId, path) =>
  `/api/v1/accounts/${accountId}/proxy/knowledge${path}`;

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getScheduledMessages(_state) {
    return _state.records;
  },
};

export const actions = {
  async fetchScheduleMessages({ commit, rootGetters }, query) {
    const accountId = rootGetters.getCurrentAccountId;
    commit('setUiFlags', { isFetching: true });
    const params = query ? `?${query}` : '';
    try {
      const { data: response } = await axios.get(
        knowledgeProxy(accountId, `/accounts/${accountId}/scheduled_messages${params}`)
      );

      commit('setRecords', response.results);
      return response;
    } catch (error) {
      const errorMessages = error.response?.data?.detail?.map(e => e.msg).filter(Boolean);
      throw new Error(
        errorMessages?.length
          ? errorMessages.join('. ')
          : 'Error fetching scheduled messages'
      );
    } finally {
      commit('setUiFlags', { isFetching: false });
    }
  },

  async createScheduledMessage({ commit, rootGetters, dispatch }, payload) {
    const accountId = rootGetters.getCurrentAccountId;
    commit('setUiFlags', { isCreating: true });
    try {
      const { data: response } = await axios.post(
        knowledgeProxy(accountId, `/accounts/${accountId}/scheduled_messages`),
        payload
      );

      const query = `conversation_id=${payload.conversation_id}&status=pending`;
      dispatch('fetchScheduleMessages', query);
      return response;
    } catch (error) {
      const errorMessages = error.response?.data?.detail?.map(e => e.msg).filter(Boolean);
      throw new Error(
        errorMessages?.length
          ? errorMessages.join('. ')
          : 'Error creating scheduled message'
      );
    } finally {
      commit('setUiFlags', { isCreating: false });
    }
  },
  
  async updateScheduledMessage({ commit, rootGetters }, { messageId, payload }) {
    const accountId = rootGetters.getCurrentAccountId;
    commit('setUiFlags', { isUpdating: true });
    try {
      const { data: response } = await axios.put(
        knowledgeProxy(accountId, `/accounts/${accountId}/scheduled_messages/${messageId}`),
        payload
      );
      return response;
    } catch (error) {
      const errorMessages = error.response?.data?.detail?.map(e => e.msg).filter(Boolean);
      throw new Error(
        errorMessages?.length
          ? errorMessages.join('. ')
          : 'Error updating scheduled message'
      );
    } finally {
      commit('setUiFlags', { isUpdating: false });
    }
  },

  async deleteScheduledMessage({ commit, rootGetters }, messageId) {
    const accountId = rootGetters.getCurrentAccountId;
    commit('setUiFlags', { isDeleting: true });
    try {
      await axios.delete(
        knowledgeProxy(accountId, `/accounts/${accountId}/scheduled_messages/${messageId}`)
      );
      return true;
    } catch (error) {
      const errorMessages = error.response?.data?.detail?.map(e => e.msg).filter(Boolean);
      throw new Error(
        errorMessages?.length
          ? errorMessages.join('. ')
          : 'Error deleting scheduled message'
      );
    } finally {
      commit('setUiFlags', { isDeleting: false });
    }
  },
};

export const mutations = {
  setUiFlags(state, data) {
    state.uiFlags = { ...state.uiFlags, ...data };
  },
  setRecords(state, data) {
    state.records = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
